<template>
  <svg
    viewBox="0 0 16 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.25159 13.1417L0 7.89006L2.39323 5.49683L5.25159 8.36364L13.6068 0L16 2.39323L5.25159 13.1417Z" />
  </svg>
</template>
